import { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';
import PasswordStrength from '../PasswordStrength';
import adminAPI from '../../API/adminAPI';
import styles from './SignupComponent.module.css';

export default function SignupComponent(props) {
    // ----- STATE INITIALIZATION -----
    const {
        loginRedirect,
        handleSignUp,
        password,
        setPassword,
        setUp,
        email,
        setEmail,
        isLoading,
        inviteData,
    } = props;

    // state initialization
    const [ emailValid , setEmailValid ] = useState(false);
    const [ message, setMessage ] = useState('');
    const [ inputType, setInputType ] = useState('password');
    const [ localLoading, setLocalLoading ] = useState(false);

    // usecallback prevents debounce recreation
    const checkEmailAvailability = useCallback(
        debounce(async (search) => {
            try {
                const res = await adminAPI.getUserByEmail(search);
                if (res.data) {
                    setEmailValid(false);
                    setMessage('unavailable');
                } else {
                    setEmailValid(true);
                    setMessage('');
                }
            } catch (err) {
                console.error("Error checking email:", err);
            }
        },500),
    []);

    useEffect(() => {
        const emailRE = new RegExp(/[^@]+@[^@]+\.[^@]+/);

        if (email.length > 0) {
            if (emailRE.test(email)) {
                // only run check if email is valid
                checkEmailAvailability(email);
            } else {
                setEmailValid(false);
                setMessage('');
            }
        } else {
            setEmailValid(false);
            setMessage('');
        }

        return () => checkEmailAvailability.cancel();
    },[email, checkEmailAvailability]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLocalLoading(true);
        handleSignUp().finally(() => {
            setLocalLoading(false);
        });
    };

    const isSubmitDisabled = !emailValid || password?.length < 1 || isLoading || localLoading;

    return (
        <form className={styles.form} onSubmit={handleSubmit} style={setUp === true ? {padding: '0 1rem'} :{}}>
            {setUp === true ? <></> : 
              <>
                <h2 className='text-center mb-2'>Sign Up</h2>
                {!inviteData && (
                    <div className={styles.existing}>
                        Already a user? <span onClick={loginRedirect}>LOGIN</span>
                    </div>
                )}
                {inviteData && (
                    <div className={styles.inviteInfo}>
                        You're joining an organization on LiquidQR
                    </div>
                )}
              </>
            }
            <div className={styles.inputGroup}>
                <input
                    type='email'
                    id='signup-email'
                    value={email}
                    className={styles.input}
                    onChange={(e) => {setEmail(e.target.value)}}
                    autoComplete="off"
                    required
                    style={(email?.length > 0 && !emailValid) ? {border: '2px solid red'} : null}
                />
                <label htmlFor='signup-email' className={styles.label} style={message?.length > 0 ? {color: 'red'} : null}>Email</label>
                {message?.length > 0 && <div className={styles.message}>{message}</div>}
                {email?.length > 0 &&
                    <div className={styles.icon}>
                        <i 
                            className={emailValid ? 'far fa-check-circle' : 'far fa-times-circle'} 
                            style={emailValid ? {color: 'green'} : {color: 'red'}}    
                        />
                    </div>
                }
            </div>
            <div className={styles.inputGroup}>
                <input
                    type={inputType}
                    id='signup-password'
                    value={password}
                    className={styles.input}
                    onChange={(e) => {setPassword(e.target.value)}}
                    autoComplete="off"
                    required
                />
                <label htmlFor='signup-password' className={styles.label}>Password</label>
                <button 
                    type='button'
                    className={styles.hidePassword} 
                    onClick={() => setInputType(inputType === 'password' ? 'text' : 'password')} 
                    disabled={password?.length < 1}
                >
                    {inputType === 'password' ? <i className='fas fa-eye' /> : <i className='fas fa-eye-slash' />}
                </button>
                <PasswordStrength password={password} />
            </div>
            {/* {gen_id && <GeneratorQRDisplay gen_id={gen_id} state={state} setState={setState} />} */}
            <div className={styles.inputGroup} style={{justifyContent: 'center'}}>
                <button 
                    type='submit' 
                    className={styles.btn} 
                    disabled={isSubmitDisabled}
                >
                    {isLoading || localLoading ? 'Submitting...' : 'Submit'}
                </button>
            </div>
        </form>
    );
};